// extracted by mini-css-extract-plugin
export default {"root":"HeroImage-root","overlay":"HeroImage-overlay","content":"HeroImage-content"};